import { render, staticRenderFns } from "./datepaper.vue?vue&type=template&id=106159fa&scoped=true"
import script from "./datepaper.vue?vue&type=script&lang=js"
export * from "./datepaper.vue?vue&type=script&lang=js"
import style0 from "./datepaper.vue?vue&type=style&index=0&id=106159fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106159fa",
  null
  
)

export default component.exports